import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Is this safe for kids?",
    answer: "Absolutely! All stories are generated with strict content guidelines. We filter out any inappropriate content and ensure all stories are age-appropriate, educational, and positive. No violence, no scary content — just wholesome fun.",
  },
  {
    question: "How do you ensure age-appropriate stories?",
    answer: "Our AI is specifically trained to create stories for children aged 2-10. We use vocabulary appropriate for young listeners, simple sentence structures, and themes that are suitable for kids. Parents can also choose specific age ranges for more tailored content.",
  },
  {
    question: "How do I download stories?",
    answer: "Premium subscribers can download stories directly to their device. Just tap the download button on any story to save it for offline listening — perfect for car rides or areas without internet!",
  },
  {
    question: "Do you support other languages?",
    answer: "Currently, our stories are in English but we're working on adding support for other languages soon. Stay tuned!",
  },
  {
    question: "Can siblings share an account?",
    answer: "Yes! You can create stories for multiple children under one account. Each story is personalized with the child's name you enter at the time of generation. Many families create stories for all their kids!",
  },
  // {
  //   question: "What if I'm not satisfied?",
  //   answer: "We offer a 100% satisfaction guarantee. If you're not happy with our service within the first 7 days of your subscription, we'll refund your payment — no questions asked.",
  // },
];

const FAQSection = () => {
  return (
    <section id="faq" className="py-16 md:py-24 px-4 bg-gradient-to-b from-background to-[hsl(var(--playful-pink),0.05)]">
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-[hsl(var(--playful-pink),0.2)] text-[hsl(var(--playful-pink))] rounded-full text-sm font-medium mb-4">
            Questions?
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Frequently Asked{" "}
            <span className="bg-gradient-to-r from-[hsl(var(--playful-pink))] to-[hsl(var(--playful-purple))] bg-clip-text text-transparent">
              Questions
            </span>
          </h2>
          <p className="text-muted-foreground">
            Everything parents want to know before getting started.
          </p>
        </div>

        <div className="bg-card rounded-3xl p-6 md:p-8 shadow-lg border border-border">
          <Accordion type="single" collapsible className="space-y-2">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-border/50 last:border-0"
              >
                <AccordionTrigger className="text-left font-display font-semibold text-foreground hover:text-[hsl(var(--playful-pink))] py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="text-center mt-8">
          <p className="text-muted-foreground">
            Still have questions?{" "}
            <Link to="/contact" className="text-[hsl(var(--playful-pink))] font-medium hover:underline">
              Contact us
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
